export const TABLE_FAKE_COLUMN_NAME = 'fakeColumn';
